module.exports = __webpack_public_path__ + "img/265-4.030e6060.jpg";